import React from "react";


export default function fcDisplayResponse(props) {

    function isNumber(num){
        return !isNaN(parseFloat(num)) && isFinite(num);
    }

    let fcName, fcEmail, fcPhone, fcAddress1, fcAddress2, fcCity, fcState, fcZip, compensationStatements, commissions, managementCompensation, variableManagementComp, currentAccess
    let identifier = props.searchValue;
    if (isNumber(identifier)) {
        identifier = identifier + ' - (' + props.fcresponse[0].eid + ')'
    }
    const firmContactEid = props.fcDisplayResponse.eid
    let firmName = 'unknown'
    if (props.fcresponse[0].name) {
        firmName = props.fcresponse[0].name.lastName
    }
    if(props.fcDisplayResponse.name !== null && props.fcDisplayResponse.name !== undefined) {
        fcName = props.fcDisplayResponse.name.firstName + ' ' + props.fcDisplayResponse.name.middleName + ' ' + props.fcDisplayResponse.name.lastName + ' ' + props.fcDisplayResponse.name.suffix
    }

    if(props.fcDisplayResponse.emailAddressList !== null && props.fcDisplayResponse.emailAddressList !== undefined && props.fcDisplayResponse.emailAddressList.length !== 0) {
        fcEmail = props.fcDisplayResponse.emailAddressList[0].email
    }

    if(props.fcDisplayResponse.phoneNumberList !== null && props.fcDisplayResponse.phoneNumberList !== undefined && props.fcDisplayResponse.phoneNumberList.length !== 0) {
        fcPhone = props.fcDisplayResponse.phoneNumberList[0].areaCode +  ' ' + props.fcDisplayResponse.phoneNumberList[0].number
    }

    if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
        fcAddress1 = props.fcDisplayResponse.postalAddressList[0].addressLine1
    }

    if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
        fcAddress2 = props.fcDisplayResponse.postalAddressList[0].addressLine2
    }

    if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
        fcCity = props.fcDisplayResponse.postalAddressList[0].city
    }

    if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
        fcState = props.fcDisplayResponse.postalAddressList[0].state
    }

    if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
        fcZip = props.fcDisplayResponse.postalAddressList[0].zipCode
    }

    if (props.fcDisplayResponse.delegateAccess.accountAccess.currentAccess === "A") {
        currentAccess = "All"
    }  else {
        currentAccess = "None"
    }

    for (let i = 0; i < props.fcDisplayResponse.delegateAccess.applicationAccess.length; i++) {
        if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "2"){
            compensationStatements = convertBooleanToYN(props.fcDisplayResponse.delegateAccess.applicationAccess[i].access);
        } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "3"){
            commissions = convertBooleanToYN(props.fcDisplayResponse.delegateAccess.applicationAccess[i].access);
        } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "4"){
            managementCompensation = convertBooleanToYN(props.fcDisplayResponse.delegateAccess.applicationAccess[i].access);
        } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "5"){
            variableManagementComp = convertBooleanToYN(props.fcDisplayResponse.delegateAccess.applicationAccess[i].access);
        }
    }

    function returnToFcList() {
        props.setFcDisplayResponse(null)
        props.setGlobalAlert(
            {
              hidden: true,
            }
          )
    }

    function enableEditMode() {
        props.setFcEditMode(true)
        props.setGlobalAlert(
            {
              hidden: true,
            }
          )
    }

    function enableDeleteMode() {
        props.setFcDeleteMode(true)
        props.setGlobalAlert(
            {
              hidden: true,
            }
          )
    }

    function returnToSearch() {
        props.setFcDisplayResponse(null)
        props.setfcResponse(null)
        props.setGlobalAlert(
            {
              hidden: true,
            }
          )
    }

    function convertBooleanToYN(input) {
        if(input) {
          return "Yes";
        } else {
          return "No";
        }
      }
    

    return(
        <div>
            <h3>Firm Information</h3>
            <strong>Firm Name:</strong> {`${firmName}`} <br></br>
            <strong>Firm Identifier:</strong> {`${identifier}`} <br></br>
            <h3>Firm Contact Information</h3>
            <table>
              <tbody>  
                <tr>
                    <td className="col-8">
                        <strong>Firm Contact EID : </strong> {`${firmContactEid}`} 
                    </td>
                    <td className="col-8">
                        <strong>Line 1 Address : </strong> {`${fcAddress1}`} 
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Firm Contact Name : </strong> {`${fcName}`} 
                    </td>
                    <td className="col-8">
                    <strong>Line 2 Address : </strong> {`${fcAddress2}`}
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Email Address : </strong> {`${fcEmail}`} 
                    </td>
                    <td className="col-8">
                    <strong>City : </strong> {`${fcCity}`}
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Phone Number : </strong>  {`${fcPhone}`} 
                    </td>
                    <td className="col-8">
                    <strong>State : </strong> {`${fcState}`}
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    </td>
                    <td className="col-8">
                    <strong>ZIP Code : </strong> {`${fcZip}`} <br></br><br></br>
                    </td>
                </tr>

        
                <tr>
                    <td className="col-8">
                <strong>Compensation Statement Access : </strong> {`${compensationStatements}`} 
                </td>
                <td className="col-8">
                <strong>Account Access : </strong> {`${currentAccess}`} 
                </td>
                </tr>
                <tr>
                    <td className="col-8">
                <strong>Commissions Access : </strong> {`${commissions}`} 
                </td>
                <td className="col-8"></td>
                </tr>
                <tr>
                    <td className="col-8">
                <strong>Management Compenesation Access : </strong> {`${managementCompensation}`} 
                </td>
                <td className="col-8"></td>
                </tr>
                <tr>
                    <td className="col-8">
                <strong>Variable Management Access : </strong> {`${variableManagementComp}`} 
                </td>
                <td className="col-8"></td>
                </tr>
              </tbody>
            </table>
            <br></br>
            {props.admin ? 
            <button
                className="pds-button pds-button-primary"
                data-gtm="modal-cta"
                id="editModeButton"
                onClick={enableEditMode}
                >
                Edit Firm Contact
            </button> :
            <></>
            }
            &nbsp;
            {props.admin ? 
            <button
                className="pds-button pds-button-primary"
                data-gtm="modal-cta"
                id="deleteButton"
                onClick={enableDeleteMode} 
                >
                Delete Firm Contact
            </button> :
            <></>
            }
            &nbsp;
            <button
                className="pds-button pds-button-secondary"
                data-gtm="modal-cta"
                id="searchfirmButton"
                onClick={returnToSearch}
                >
                Return to Firm Search
            </button>
            &nbsp;
            <button
                className="pds-button pds-button-secondary"
                data-gtm="modal-cta"
                id ="firmFcListButton"
                onClick={returnToFcList}  
                >
                Return to List
            </button>

            
            <br></br>
            <br></br>
            If you have any questions, need assistance or would like to delete an existing Firm Contact, call 800-554-3395 or email advisorwebsupport@principal.com.
        </div>
    )




}